module.exports = __webpack_public_path__ + "images/5a5ccf8a5173ddd6b4cd3883cd1d22ae-magellan-award2022.png";